import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" TopWay ")
const _hoisted_2 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CFooter = _resolveComponent("CFooter")!

  return (_openBlock(), _createBlock(_component_CFooter, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("span", _hoisted_2, "© " + _toDisplayString(new Date().getFullYear()), 1)
      ])
    ]),
    _: 1
  }))
}